export default __webpack_public_path__ + "static/media/team72.20da2358.JPG";